<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Reservation Details</h4>
    <hr>
    <Spinner v-if="isFetching" />
    <div v-if="!isFetching" class="mb-3">
      <h4>{{ reservation.station }}</h4>
      <b-row>
        <b-col md="2">
          Reservation ID:
        </b-col>
        <b-col md="2" class="font-weight-bold">
          {{ reservation.reservationId }}
        </b-col>
        <b-col md="2">
          Reservation Start:
        </b-col>
        <b-col md="2" class="font-weight-bold">
          {{ reservation.reservationStart | date }}
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2">
          Reservation End:
        </b-col>
        <b-col md="2" class="font-weight-bold">
          {{ reservation.reservationEnd | date }}
        </b-col>
        <b-col md="2">
          Vehicle:
        </b-col>
        <b-col md="2" class="font-weight-bold">
          {{ reservation.car }}
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-btn
            variant="success"
            :disabled="isSetLockUnlock"
            :class="{'mb-2 d-block': $mq === 'sm'}"
            class="mr-3"
            @click="lockUnlock('unlock')">
            <i class="icon-lock-open" />&nbsp;
            Unlock Car
          </b-btn>
          <b-btn
            variant="success"
            :disabled="isSetLockUnlock"
            :class="{'mb-2 d-block': $mq === 'sm'}"
            class="mr-3"
            @click="lockUnlock('lock')">
            <i class="icon-lock" />&nbsp;
            Lock Car
          </b-btn>
          <b-btn
              variant="success"
              :disabled="isSetImmobilizer"
              :class="{'mb-2 d-block': $mq === 'sm'}"
              class="mr-3"
              @click="setImmobilizer('unblock')">
              <i class="icon-lock-open" />&nbsp;
              Unlock Immobilizer
            </b-btn>
            <b-btn
              variant="success"
              :disabled="isSetImmobilizer"
              :class="{'mb-2 d-block': $mq === 'sm'}"
              class="mr-3"
              @click="setImmobilizer('unblock')">
              <i class="icon-lock-open" />&nbsp;
              Unlock Immobilizer
            </b-btn>
            <b-btn
              variant="success"
              :disabled="isRevoking"
              :class="{'mb-2 d-block': $mq === 'sm'}"
              class="mr-3"
              @click="revokeReservation">
              <i class="icon-wrench" />&nbsp;
              Revoke Reservation
            </b-btn>
            <b-btn
              variant="success"
              :disabled="isRetransmitting"
              :class="{'mb-2 d-block': $mq === 'sm'}"
              class="mr-3"
              @click="retransmitReservation">
              <i class="icon-refresh" />&nbsp;
              Retransmit Reservation
            </b-btn>
            <b-btn
              variant="success"
              :disabled="isFetchingGps"
              :class="{'mb-2 d-block': $mq === 'sm'}"
              class="mr-3"
              @click="showLocation">
              <i class="icon-location-pin" />&nbsp;
              Request GPS Location
            </b-btn>
            <b-btn
              variant="secondary"
              :disabled="isSetImmobilizer"
              @click="$router.go(-1)">
              Cancel
            </b-btn>
        </b-col>
        <!-- <b-col md="2" :class="{'mb-3': $mq === 'sm'}" class="is-mini">
          <b-btn
            variant="success"
            :disabled="isSetLockUnlock"
            @click="lockUnlock('unlock')">
            <i class="icon-lock-open" />&nbsp;
            Unlock Car
          </b-btn>
        </b-col>
        <b-col md="2" :class="{'mb-3': $mq === 'sm'}" class="is-mini">
          <b-btn
            variant="success"
            :disabled="isSetLockUnlock"
            @click="lockUnlock('lock')">
            <i class="icon-lock" />&nbsp;
            Lock Car
          </b-btn>
        </b-col>
        <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
          <b-btn
            variant="success"
            :disabled="isSetImmobilizer"
            @click="setImmobilizer('unblock')">
            <i class="icon-lock-open" />&nbsp;
            Unlock Immobilizer
          </b-btn>
        </b-col>
        <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
          <b-btn
            variant="success"
            :disabled="isSetImmobilizer"
            @click="setImmobilizer('block')">
            <i class="icon-lock" />&nbsp;
            Lock Immobilizer
          </b-btn>
        </b-col>
        <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
          <b-btn
            variant="success"
            :disabled="isFetchingGps"
            @click="showLocation">
            <i class="icon-location-pin" />&nbsp;
            Request GPS Location
          </b-btn>
        </b-col>
        <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
          <b-btn
            variant="success"
            :disabled="isFetchingGps"
            @click="showLocation">
            <i class="icon-location-pin" />&nbsp;
            Revoke Reservation
          </b-btn>
        </b-col>
        <b-col md="2" :class="{'mb-3': $mq === 'sm'}">
          <b-btn
            variant="success"
            :disabled="isFetchingGps"
            @click="showLocation">
            <i class="icon-location-pin" />&nbsp;
            Retransmit Reservation
          </b-btn>
        </b-col>
        <b-col md="2">
          <b-btn
            variant="secondary"
            :disabled="isSetImmobilizer"
            @click="$router.push({ name: 'Reservations' })">
            Cancel
          </b-btn>
        </b-col> -->
      </b-row>
    </div>
    <b-alert
      variant="danger"
      :show="!items.length && !isFetching">
      No fleet events found
    </b-alert>
    <b-table
      v-if="!isFetching && items.length"
      :items="items"
      :fields="fields"
      :per-page="itemsPerPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      hover
      responsive
      tbody-tr-class="clickable"
      @row-clicked="handleRowClick">
      <template v-slot:cell(timeStamp)="{ item }">
        {{ item.timeStamp | date }}
      </template>
    </b-table>
    <b-pagination
      v-show="items.length > 10"
      :total-rows="items.length"
      :per-page="itemsPerPage"
      v-model="currentPage" />
    <b-modal
      id="eventModal"
      ref="eventModal"
      :title="`${selectedItem.eventType} (${selectedItem.person})(${selectedItem.group})`"
      header-bg-variant="success"
      header-border-variant="success"
      size="lg"
      :lazy="true"
      :ok-only="true"
      ok-title="Done">
      <InlineLabel
        label="Received"
        :value="selectedItem.receivedDateTime | date" />
      <InlineLabel
        label="Device"
        :value="selectedItem.device" />
      <InlineLabel
        label="Car"
        :value="selectedItem.car" />
      <InlineLabel
        label="Zone"
        :value="selectedItem.zone" />
      <InlineLabel
        label="Station"
        :value="selectedItem.station" />
      <InlineLabel
        label="ICS Number"
        :value="selectedItem.icsNumber" />
      <InlineLabel
        label="Address End Device"
        :value="selectedItem.addressEndDevice " />
      <InlineLabel
        label="Smartcard"
        :value="selectedItem.smartCard " />
      <InlineLabel
        v-if="selectedItem.command !== null"
        label="Command"
        :value="selectedItem.command === 'True' ? 'Unlock' : 'Lock'" />
      <InlineLabel
        v-if="selectedItem.requestedPIN !== null"
        label="Requested PIN"
        :value="toSentence(selectedItem.requestedPIN)" />
      <InlineLabel
        v-if="selectedItem.pinResult !== null"
        label="PIN Result"
        :value="selectedItem.pinResult" />
      <InlineLabel
        v-if="selectedItem.pinAttempts !== null"
        label="PIN Attempts"
        :value="selectedItem.pinAttempts" />
      <InlineLabel
        v-if="selectedItem.reason !== null"
        label="Reason"
        :value="selectedItem.reason" />
      <div v-if="selectedItem.gpsLatitude && selectedItem.gpsLongitude">
        <InlineLabel
        label="GPS Latitude"
        :value="selectedItem.gpsLatitude" />
        <InlineLabel
          label="GPS Longitude"
          :value="selectedItem.gpsLongitude" />
        <a :href="`https://maps.google.com/maps?q=${this.selectedItem.gpsLatitude},${this.selectedItem.gpsLongitude}`" target="_blank">Show position on google maps</a>
      </div>
    </b-modal>

    <b-modal
      id="gpsLocationModal"
      ref="gpsLocationModal"
      title="GPS Information"
      header-bg-variant="success"
      header-border-variant="success"
      size="md"
      :lazy="true"
      :ok-only="true"
      ok-title="Done">
      <div>
        <div>
          Updated at: {{ this.gpsPosition.gpsTimeStamp | date }}
        </div>
        <div>
          Latitude: {{ this.gpsPosition.gpsLatitude }}
        </div>
        <div>
          Longitude: {{ this.gpsPosition.gpsLongitude }}
        </div>
        <b-row class="mt-3">
          <b-col>
            <iframe
              :src="mapUrl"
              width="100%"
              height="300" />
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { toastr } from '@/services'
import InlineLabel from '@/components/InlineLabel'
import Spinner from '@/components/Spinner'

export default {
  name: 'FleetEvents',
  components: {
    InlineLabel,
    Spinner
  },
  data() {
    return {
      items: [],
      eventModalVisible: false,
      isFetching: false,
      isRetransmitting: false,
      isRevoking: false,
      sortBy: 'timeStamp',
      sortDesc: true,
      fields: [
        'group',
        'eventType',
        {
          key: 'timeStamp',
          sortable: true
        },
        'device',
        'car'
      ],
      selectedItem: {},
      itemsPerPage: 10,
      currentPage: 1,
      reservationId: undefined,
      reservation: undefined,
      isFetchingReservation: false,
      isSetImmobilizer: false,
      isSetLockUnlock: false,
      mapUrl: '',
      gpsLocationModalVisible: false,
      gpsPosition: {},
      isFetchingGps: false
    }
  },
  created() {
    const { reservationId } = this.$route.params
    this.reservationId = reservationId
    this.getReservation()
    this.getFleetEvents()
  },
  methods: {
    getReservation() {
      this.$store.dispatch('cocos/getReservations', { reservationId: this.reservationId })
        .then((res) => {
          this.reservation = {
            ...this.reservation,
            ...res[0]
          }
        })
    },
    getFleetEvents() {
      this.isFetching = true
      this.$store.dispatch('cocos/getFleetEvents', { reservationId: this.reservationId })
        .then((res) => {
          if (res.length) {
            this.items = res
            this.reservation = {
              ...this.reservation,
              ...res[0]
            }
          }
          this.isFetching = false
        }).catch((err) => this.isFetching = false)
    },
    handleRowClick(item) {
      this.selectedItem = item
      this.$bvModal.show('eventModal')
    },
    setImmobilizer(command) {
      this.isSetImmobilizer = true
      const payload = {
        carId: this.reservation.carId,
        command
      }
      this.$store.dispatch('cocos/setImmobilizer', payload)
        .then((res) => {
          this.isSetImmobilizer = false
          if (!res.msgContent.errorMessage && res.msgContent.errorCode > 0) {
            toastr.info(`${command} succeed.`)
          } else {
            toastr.error(`${command} failed.`)
          }
        })
        .catch((err) => {
          this.isSetImmobilizer = false
          toastr.serverError()
        })
    },
    lockUnlock(command) {
      this.isSetLockUnlock = true
      const payload = {
        reservationId: this.reservation.reservationId,
        command,
        partner: 'whizzcar'
      }
      this.$store.dispatch('cocos/lockUnlockCar', payload)
        .then((res) => {
          this.isSetLockUnlock = false
          if (!res.msgContent.errorMessage && res.msgContent.errorCode > 0) {
            toastr.info(`${command} succeed.`)
          } else {
            toastr.error(`${command} failed.`)
          }
        })
        .catch((err) => {
          this.isSetLockUnlock = false
          toastr.serverError()
        })
    },
    showLocation() {
      this.isFetchingGps = true
      this.$store.dispatch('cocos/getCurrentPosition', { carId: this.reservation.carId })
        .then((resp) => {
          this.isFetchingGps = false
          this.gpsPosition = resp.msgContent
          this.mapUrl = `https://maps.google.com/maps?q=${this.gpsPosition.gpsLatitude},${this.gpsPosition.gpsLongitude}&z=14&output=embed`
          this.$bvModal.show('gpsLocationModal')
        })
      
    },
    toSentence(text = '') {
      if (text === '') return text
      const result = text.replace(/([A-Z])/g, ' $1')
      const finalResult = result.charAt(0).toUpperCase() + result.slice(1)

      return finalResult
    },
    revokeReservation() {
      this.isRevoking = true
      const payload = {
        reservationId: this.reservation.reservationId
      }
      this.$store.dispatch('cocos/revokeReservation', payload).then((resp) => {
        if (!resp.msgContent.errorMessage && resp.msgContent.status > 0) {
          toastr.info('Reservation has been revoked')
        } else {
          toastr.error('Failed to revoke reservation')
        }
        
        this.isRevoking = false
      }).catch((err) => {
        console.log(err)
        this.isRevoking = false
        toastr.error('Failed to revoke reservation')
      })
    },
    retransmitReservation() {
      this.isRetransmitting = true
      const payload = {
        reservationId: this.reservation.reservationId
      }
      this.$store.dispatch('cocos/retransmitReservation', payload).then((resp) => {
        if (!resp.msgContent.errorMessage && resp.msgContent.errorCode === 1) {
          toastr.info('Reservation has been retransmit')
        } else {
          toastr.error('Failed to retransmit reservation')
        }
        this.isRetransmitting = false
      }).catch((err) => {
        console.log(err)
        this.isRetransmitting = false
        toastr.error('Failed to retransmitted reservation')
      })
    }
  }
}
</script>

<style lang="scss">
.clickable {
  cursor: pointer
}
.is-mini {
  max-width: 10.6666%!important;
  padding-right: 0;
}
</style>